import MypagePresentsContainer from './MypagePresentsContainer';
export default MypagePresentsContainer;
